import { FlowPage } from 'src/lib/flow/FlowPage';
import { isEligibleForLongboardingExperiment } from 'src/lib/flow/pageHelpers';

const isEnabled: FlowPage['isEnabled'] = (context) => {
  return (
    isEligibleForLongboardingExperiment(context) &&
    context.experimentFlags.longboarding == 'treatment'
  );
};

const longboardingHomeLayoutPage: FlowPage = {
  slug: () => 'home-layout',
  title: () => 'Which best describes your home’s layout?',
  isEnabled,
  autoAdvance: () => true,
  subtitle: () =>
    'This helps us understand how your home’s features compare to similar properties.',
  questions: () => [
    {
      key: 'home.home_layout',
      type: 'radio_single_select',
      options: [
        {
          label: 'Split level',
          value: 'split_level',
        },
        {
          label: 'Split entry',
          value: 'split_entry',
        },
        {
          label: 'Open concept',
          value: 'open_concept',
        },
        {
          label: 'Split bedroom',
          value: 'split_bedroom',
        },
        {
          label: 'Not sure',
          value: 'not_sure',
        },
        {
          label: 'None of the above',
          value: 'none_of_the_above',
        },
      ],
    },
  ],
};

export default longboardingHomeLayoutPage;
